module.exports = __webpack_public_path__ + "static/media/undraw_choosing_house_v37h.014aa26e.svg";